import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import HRLayout from "../hr/HRLayout";
import useHRCopy from "../hr/i18n/useHRCopy";
import Reveal from "../hr/components/Reveal";
import PageHeader from "../hr/components/PageHeader";
import { RecordRow } from "../hr/components/ContextRail";
import ContactFormPanel from "../components/ContactFormPanel";
import ChatBot from "../components/ChatBot";
import { CONTACT_EMAIL } from "../hr/contact";

export default function IletisimPage() {
  const chatBotRef = useRef(null);
  const location = useLocation();
  const copy = useHRCopy();
  const r = copy.record;

  useEffect(() => {
    if (location.hash === "#chatbot" && chatBotRef.current) {
      chatBotRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  }, [location]);

  return (
    <HRLayout>
      <PageHeader title={copy.nav.contact} />

      {/* Channels on the left as a ruled record, the form on the right as the
          primary panel — the page's one job is getting a message sent. */}
      <section className="max-w-[1600px] mx-auto px-6 sm:px-10 lg:px-16 pb-20">
        <div className="grid gap-10 lg:gap-14 lg:grid-cols-12 items-start">
          <div className="lg:col-span-5">
            <Reveal>
              <h2 className="font-hanken font-bold uppercase text-[11px] tracking-[0.13em] text-navy">
                {r.channels}
              </h2>
              <dl className="mt-3 border-t border-line">
                <RecordRow term={r.location}>{r.locationValue}</RecordRow>
                <RecordRow term={r.email}>
                  <a
                    href={`mailto:${CONTACT_EMAIL}`}
                    className="text-navy font-semibold hover:text-royal transition-colors duration-300 break-words"
                  >
                    {CONTACT_EMAIL}
                  </a>
                </RecordRow>
              </dl>
            </Reveal>
          </div>

          <div className="lg:col-span-7">
            <Reveal delay={0.09}>
              <h2 className="font-hanken font-bold uppercase text-[11px] tracking-[0.13em] text-navy mb-3">
                {r.writeToUs}
              </h2>
            </Reveal>
            <ContactFormPanel delay={0.12} />
          </div>
        </div>
      </section>

      <div ref={chatBotRef} id="chatbot" />
      <ChatBot />
    </HRLayout>
  );
}
